module.exports = __webpack_public_path__ + "img/icon-arrow-left.5b374c8d.svg";